<template>
  <!-- 先进管理 -->
  <div
    class="advanced"
    style="height: calc(100vh - 88px); background-color: #fff"
    v-loading="loading"
  >
    <div class="tabs">
      <p class="title">江苏省检察院先进典型列表</p>
      <!-- {{ activeName }} -->

      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-if="userInfo.userLevel == '2'"
          label="待我审核"
          name="1"
        ></el-tab-pane>
        <el-tab-pane label="审核通过" name="2"></el-tab-pane>
        <el-tab-pane label="待发布" name="3"></el-tab-pane>
        <el-tab-pane label="已发布" name="4"></el-tab-pane>
        <el-tab-pane label="不发布" name="5"></el-tab-pane>
      </el-tabs>
      <!-- {{ jcy_ID }} -->
      <el-form>
        <el-form-item label="检察院">
          <!-- <el-input v-model="name"></el-input> -->
          <el-cascader
            v-model="name"
            :options="optionsList"
            :props="{ checkStrictly: true }"
            :show-all-levels="false"
            clearable
            ref="demoCascader"
            @change="handleChange"
          ></el-cascader>
        </el-form-item>
        <!-- {{ level }} -->
        <el-form-item label="获奖级别">
          <el-select
            v-model="level"
            clearable
            placeholder="请选择获奖级别"
            style="width: 100%"
          >
            <el-option label="国家级" value="国家级"></el-option>
            <el-option label="省（部）级" value="省（部）级"></el-option>
            <el-option label="厅局（市）级" value="厅局（市）级"></el-option>
            <el-option label="县（区）级" value="县（区）级"></el-option>
          </el-select>
        </el-form-item>
        <!-- {{ time }} -->
        <el-form-item label="获奖时间" style="margin-top: 2px">
          <el-date-picker
            v-model="timeValue"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            value-format="timestamp"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="性别">
          <el-select
            v-model="sex"
            clearable
            placeholder="请选择性别"
            style="width: 100%"
          >
            <el-option label="男" value="1"></el-option>
            <el-option label="女" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="政治面貌">
          <el-select
            v-model="mianmao"
            clearable
            placeholder="请选择政治面貌"
            style="width: 100%"
          >
            <el-option label="中共党员" value="中共党员"></el-option>
            <el-option label="民主党派" value="民主党派"></el-option>
            <el-option label="无党派" value="无党派"></el-option>
            <el-option label="群众" value="群众"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="年龄">
          <el-date-picker
            v-model="ageValue"
            end-placeholder="结束日期"
            format="yyyy 年 MM 月 dd 日"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <el-form-item label="荣誉名称">
          <el-input
            v-model="leibie"
            clearable
            placeholder="请输入"
            style="width: 100%"
          >
          </el-input>
        </el-form-item>

        <el-form-item label="先进姓名">
          <el-input
            v-model="userName"
            clearable
            placeholder="请输入"
            style="width: 100%"
          >
          </el-input>
        </el-form-item>

        <el-form-item>
          <el-button
            style="height: 36px; display: flex; align-items: center"
            type="primary"
            @click="sou"
            >搜索
          </el-button>
        </el-form-item>
      </el-form>

      <el-table :data="tableData" border style="width: 100%">
        <el-table-column label="先进姓名" prop="username"></el-table-column>
        <el-table-column label="性别" prop="sex">
          <template slot-scope="scope">
            <span>{{ scope.row.sex == 1 ? "男" : "女" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="出生年月" prop="birth"></el-table-column>
        <el-table-column label="籍贯" prop="native_place"></el-table-column>
        <el-table-column label="政治面貌" prop="outlook"></el-table-column>
        <el-table-column label="所属检察院" prop="jcy_name" width="120">
        </el-table-column>
        <el-table-column
          label="所属检察院（部）职别"
          prop="position"
          width="180"
        >
        </el-table-column>
        <el-table-column label="所获荣誉" prop="honor">
          <template slot-scope="scope">
            <span>{{ scope.row.honor | honorFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="宣传报道" prop="publicity">
          <template slot-scope="scope">
            <span>{{ scope.row.publicity | honorFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="审核状态" prop="state">
          <template slot-scope="scope">
            <span>{{ scope.row.state | stateFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="">
          <template slot-scope="scope">
            <div>
              <span class="shou" @click="look(scope.row)">查看</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <el-pagination
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PersonalCenter from "./personal-center/personal-center";
import { regionList, userlistPost, pluginsListApi } from "@/api/open";
import { times } from "@/filters/index";
import { mapGetters } from "vuex";

export default {
  components: {
    PersonalCenter,
  },
  filters: {
    honorFilter(val) {
      return val == null || val == "" ? 0 : JSON.parse(val).length;
    },
    stateFilter(val) {
      let tit = "";
      switch (val) {
        case 1:
          tit = "待审核";
          break;
        case 2:
          tit = "已审核";
          break;
        case 3:
          tit = "待发布";
          break;
        case 4:
          tit = "已发布";
          break;
        case 5:
          tit = "不发布";
          break;
        case 6:
          tit = "审核不通过";
          break;
        default:
          tit = "草稿";
          break;
      }
      return tit;
    },
  },
  data() {
    return {
      loading: false,
      isLook: false, //查看
      activeName: "1",
      time: "",
      level: "",
      name: "",
      sex: "",
      agey: "",
      mianmao: "",
      total: 0,
      leibie: "",
      userName: "",
      page: 1,
      pageSize: 15,
      restaurants: [],
      tableData: [],
      jcy_ID: "",
      optionsList: [],
      jcyObj: {},
      regionLevel: "",
      jacy1: "",
      jacy2: "",
      jacy3: "",
      timeValue: "",
      ageValue: "",
      isFirst: 1,
    };
  },
  computed: { ...mapGetters(["userInfo"]) },
  methods: {
    handleChange(value) {
      console.log(value);
      if (value.length > 0) {
        console.log(this.name);
        this.isFirst = 0;
        this.jacy1 = "";
        this.jacy2 = "";
        this.jacy3 = "";
        const obj = this.$refs["demoCascader"].getCheckedNodes();
        if (obj[0]) {
          this.regionLevel = obj[0].data.level;
        }

        console.log(this.regionLevel);
      } else {
        this.isFirst = 1;
        if (this.userInfo.jcy1) {
          this.regionLevel = 1;
          this.jacy1 = this.userInfo.jcy1;
        }
        if (this.userInfo.jcy2) {
          this.regionLevel = 2;
          this.jacy2 = this.userInfo.jcy2;
        }
        if (this.userInfo.jcy3) {
          this.regionLevel = 3;
          this.jacy3 = this.userInfo.jcy3;
        }
      }
    },
    handleClick(tab, event) {
      // console.log(tab, event);
      this.page = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.page = val;
      this.getList();
    },

    querySearchAsync(queryString, cb) {
      var restaurants = this.restaurants;
      var results = queryString
        ? restaurants.filter(this.createStateFilter(queryString))
        : restaurants;

      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        cb(results);
      }, 1000 * Math.random());
    },
    createStateFilter(queryString) {
      return (state) => {
        return (
          state.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1
        );
      };
    },
    handleSelect(item) {
      this.jcyObj = item;
      this.jcy_ID = item.id;
    },
    look(val) {
      // console.log(val);
      // sessionStorage.setItem("jcy_name",val.jcy_name)
      // this.$router.push("/taggingManage/look-advanced");
      // this.isLook = true;
      // this.$router.push({
      //   path: "/taggingManage/look-advanced",
      //   query: {
      //     id: val.id,
      //     tabId: this.activeName,
      //   },
      // });

      //新开页
      sessionStorage.setItem("jcy_name", val.jcy_name);
      this.isLook = true;
      const url = this.$router.resolve({
        path: "/taggingManage/look-advanced",
        query: {
          id: val.id,
          tabId: this.activeName,
        },
      }).href;
      window.open(url, "_blank");
    },
    getList() {
      this.loading = true;
      let t = this.time[0] + " - " + times(this.time[1]);
      let Id = "";
      let jcy1 = "";
      let jcy2 = "";
      let jcy3 = "";
      //   let jcy1 = this.userInfo.jcy1;
      //   let jcy2 = this.userInfo.jcy2;
      //   let jcy3 = this.userInfo.jcy3;
      if (this.name == "") {
        Id = "";
        jcy1 = this.userInfo.jcy1;
        jcy2 = "";
        jcy3 = "";
      }
      if (this.optionsList.name == "江苏省") {
        if (this.name.length == 3) {
          Id = this.name[this.name.length - 1];
          jcy1 = this.name[0];
          jcy2 = this.name[1];
          jcy3 = this.name[2];
        } else if (this.name.length == 2) {
          jcy1 = this.name[0];
          jcy2 = this.name[1];
          jcy3 = "";
          Id = this.name[this.name.length - 1];
        } else if (this.name.length == 1) {
          jcy1 = this.name[0];
          jcy2 = "";
          jcy3 = "";
          Id = this.name[this.name.length - 1];
        }
      } else {
        if (this.name.length == 3) {
          Id = this.name[this.name.length - 1];
          jcy1 = this.name[0];
          jcy2 = this.name[1];
          jcy3 = this.name[2];
        } else if (this.name.length == 2) {
          jcy1 = "";
          jcy2 = this.name[0];
          jcy3 = this.name[1];
          Id = this.name[this.name.length - 1];
        } else if (this.name.length == 1) {
          jcy1 = "";
          jcy2 = this.name[0];
          jcy3 = "";
          Id = this.name[this.name.length - 1];
        }
      }
      let parmas = {
        jcy_id: Id == "" ? this.userInfo.jcy_id : Id, //检察院id
        level: this.level, //级别
        page: this.page,
        regionLevel: this.regionLevel,
        pageSize: this.pageSize,
        status: Number(this.activeName),
        startTime: this.timeValue ? this.timefliter1(this.timeValue[0]) : "",
        endTime: this.timeValue
          ? this.timefliter1(this.timeValue[1]) + 86399
          : "",
        ageStart: this.ageValue ? this.timefliter1(this.ageValue[0]) : "",
        ageEnd: this.ageValue ? this.timefliter1(this.ageValue[1]) + 86399 : "",
        isFirst: this.isFirst == 0 ? 0 : 1,
        // jcy1: jcy1,
        // jcy2: jcy2,
        // jcy3: jcy3,
        jcy1: jcy1 ? jcy1 : this.jacy1,
        jcy2: jcy2 ? jcy2 : this.jacy2,
        jcy3: jcy3 ? jcy3 : this.jacy3,
        jcy: Id,
        age: this.agey == "" ? "" : this.agey[0] + " - " + times(this.agey[1]),
        sex: Number(this.sex) == 0 ? -1 : Number(this.sex),
        outLook: this.mianmao,
        name: this.leibie,
        userName: this.userName,
        user_id: this.userInfo.id,
      };
      console.log(typeof parmas.endTime);
      pluginsListApi(parmas).then((res) => {
        this.loading = false;
        if (res.code == 200) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    //搜索
    sou() {
      this.page = 1;
      this.getList();
    },
    // 过滤时间
    timefliter1(time) {
      if (time) {
        let oDate = new Date(time);
        let time1 = oDate.getTime();
        let time2 = time1 / 1000;
        return time2;
      } else return "";
    },
  },
  watch: {
    name(val) {
      if (val == "") {
        this.jcy_ID = "";
      }
    },
    agey(val) {
      if (val == "" || val == null) {
        this.agey = "";
      }
    },
  },
  mounted() {
    console.log(this.userInfo);
    if (this.userInfo.jcy1) {
      this.regionLevel = 1;
      this.jacy1 = this.userInfo.jcy1;
    }
    if (this.userInfo.jcy2) {
      this.regionLevel = 2;
      this.jacy2 = this.userInfo.jcy2;
    }
    if (this.userInfo.jcy3) {
      this.regionLevel = 3;
      this.jacy3 = this.userInfo.jcy3;
    }
    let parmas = {
      jcy1: this.userInfo.jcy1,
      jcy2: this.userInfo.jcy2,
      jcy3: this.userInfo.jcy3,
    };
    regionList(parmas).then((res) => {
      if (res.code == 200) {
        this.optionsList = res.data;
        console.log(this.optionsList);
        console.log(this.optionsList.length);
      }
    });

    if (this.userInfo.userLevel == "2") {
      this.activeName = "1";
    } else {
      this.activeName = "2";
    }
    this.getList();
  },
  activated() {
    // this.getList();
  },
};
</script>

<style lang="scss" scoped>
.advanced {
  padding: 10px 20px;
  overflow: scroll;

  .title {
    color: rgba(102, 102, 102, 100);
    font-size: 20px;
    margin-bottom: 25px;
  }

  .tabs {
    /deep/ .el-tabs__item.is-active {
      background: #66b1ff;
      color: #ffffff;
      border: 1px solid #66b1ff;
    }
  }
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__nav {
  border-radius: 10px 10px 0 0;
  border: none;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item {
  border-radius: 10px 10px 0 0;
  border: 1px solid rgba(187, 187, 187, 100);
  min-width: 100px;
  text-align: center;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border: none;
}

.el-form {
  display: flex;
  flex-wrap: wrap;
  // align-items: center;
}

.el-form-item {
  display: flex;
  margin-left: 10px;
  margin-bottom: 15px;
}

/deep/ .el-input__inner {
  height: 36px;
}

/deep/ .el-date-editor .el-range-separator {
  padding: 0;
}

/deep/ .el-table .el-table__cell {
  padding: 0.5rem 0;
  font-size: 14px;
}

/deep/ .el-table--border {
  border-bottom: 1px solid #ebeef5;
}

.page {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.shou {
  cursor: pointer;
}

/deep/ .el-form-item__content {
  // line-height: 1;
}
</style>
